import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import Select, { ValueType } from 'react-select';

export const PaginationDropDownList = [
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 50, label: 50 },
  { value: 100, label: 100 }
];

export interface PaginatedItemsProps {
  itemsPerPage: number;
  itemCounts: number;
  offset: number;
  handlePageChange: (pageNumber: number) => void;
  handleItemsPerPage: (itemsNumber: number) => void;
}
export const Pagination: React.FC<PaginatedItemsProps> = ({
  itemsPerPage,
  itemCounts,
  handlePageChange,
  offset,
  handleItemsPerPage
}) => {
  const [pageCount, setPageCount] = useState(0);
  const menuPortalTarget = typeof document !== 'undefined' ? document.body : undefined;

  useEffect(() => {
    setPageCount(Math.ceil(itemCounts / itemsPerPage));
  }, [itemCounts, itemsPerPage]);
  const handlePageClick = (event: any) => {
    handlePageChange(event.selected + 1);
  };

  const safeOffset = Math.max(1, offset || 1);
  const from = itemCounts > 0 ? (safeOffset - 1) * itemsPerPage + 1 : 0;
  const to = Math.min(safeOffset * itemsPerPage, itemCounts);

  return (
    <div className="w-full my-8">
      <div className="flex flex-col gap-4 md:gap-40 md:flex-row md:items-center justify-center rounded-2xl border border-gray-200 bg-gradient-to-br from-white to-gray-50/50 px-5 py-4 shadow-md backdrop-blur-sm transition-all duration-200 hover:shadow-lg">
        {/* Showing X to Y of Z */}
        <div className="flex flex-wrap justify-center md:justify-normal  items-center gap-2 text-sm font-medium text-gray-600 order-2 md:order-1">
          <span className="text-gray-500">Showing</span>
          <span className="inline-flex items-center justify-center min-w-[2rem] px-2 py-0.5 bg-primary-50 text-primary-700 rounded-md font-bold">
            {from}
          </span>
          <span className="text-gray-500">to</span>
          <span className="inline-flex items-center justify-center min-w-[2rem] px-2 py-0.5 bg-primary-50 text-primary-700 rounded-md font-bold">
            {to}
          </span>
          <span className="text-gray-500">of</span>
          <span className="inline-flex items-center justify-center min-w-[2rem] px-2 py-0.5 bg-gray-100 text-gray-900 rounded-md font-bold">
            {itemCounts}
          </span>
        </div>

        {/* Pagination Controls */}
        <div
          className="order-1 md:order-2 w-full md:w-auto  md:overflow-visible"
          aria-label="Pagination"
        >
          {pageCount > 1 ? (
            <ReactPaginate
              breakLabel="..."
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={pageCount}
              nextLabel={
                <span>
                  <span className="hidden sm:inline">Next</span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    className="transition-transform group-hover:translate-x-0.5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.21 14.77a.75.75 0 0 1 .02-1.06L10.94 10 7.23 6.29a.75.75 0 1 1 1.06-1.06l4.24 4.24c.3.3.3.77 0 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              }
              previousLabel={
                <span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    className="transition-transform group-hover:-translate-x-0.5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.79 5.23a.75.75 0 0 1-.02 1.06L9.06 10l3.71 3.71a.75.75 0 1 1-1.06 1.06l-4.24-4.24a.75.75 0 0 1 0-1.06l4.24-4.24a.75.75 0 0 1 1.06 0Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="hidden sm:inline">Previous</span>
                </span>
              }
              renderOnZeroPageCount={null}
              forcePage={Math.max(0, safeOffset - 1)}
              containerClassName="flex items-center gap-1 sm:gap-1.5 w-max mx-auto md:mx-0"
              pageLinkClassName="group inline-flex items-center justify-center min-w-[2.25rem] sm:min-w-[2.5rem] h-9 sm:h-10 px-3 sm:px-3.5 rounded-lg text-sm font-semibold text-gray-700 bg-white border border-gray-200 hover:bg-primary-50 hover:text-primary-700 hover:border-primary-300 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 shadow-sm hover:shadow"
              previousLinkClassName="group inline-flex items-center justify-center h-9 sm:h-10 px-3 sm:px-3.5 rounded-lg text-sm font-semibold text-gray-700 bg-white border border-gray-200 hover:bg-primary-50 hover:text-primary-700 hover:border-primary-300 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 shadow-sm hover:shadow"
              nextLinkClassName="group inline-flex items-center justify-center h-9 sm:h-10 px-3 sm:px-3.5 rounded-lg text-sm font-semibold text-gray-700 bg-white border border-gray-200 hover:bg-primary-50 hover:text-primary-700 hover:border-primary-300 active:scale-95 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 shadow-sm hover:shadow"
              breakLinkClassName="inline-flex items-center justify-center min-w-[2.25rem] sm:min-w-[2.5rem] h-9 sm:h-10 px-2.5 sm:px-3 rounded-lg text-gray-400 font-medium"
              activeLinkClassName="!bg-primary-500 !text-white !border-primary-600 !shadow-md hover:!bg-primary-600 hover:!border-primary-700"
              disabledLinkClassName="!text-gray-300 !bg-gray-50 !border-gray-200 !cursor-not-allowed hover:!bg-gray-50 hover:!text-gray-300 hover:!border-gray-200 !opacity-50"
              pageClassName="list-none"
              previousClassName=" h-8"
              nextClassName=" h-8"
              breakClassName="list-none"
            />
          ) : null}
        </div>

        {/* Rows per page selector */}
        <div className="flex items-center justify-center md:justify-normal gap-3 text-sm font-medium text-gray-600 order-3">
          <span className="whitespace-nowrap text-gray-500">Rows per page</span>
          <Select
            value={{ value: itemsPerPage, label: itemsPerPage }}
            options={PaginationDropDownList}
            className="w-32 sm:w-40"
            isSearchable={false}
            menuPlacement="top"
            menuPosition="fixed"
            menuPortalTarget={menuPortalTarget}
            maxMenuHeight={220}
            styles={{
              control: (base: any, state: any) => ({
                ...base,
                minHeight: '40px',
                height: '40px',
                borderColor: state.isFocused ? '#237c58' : '#e5e7eb',
                fontSize: '0.875rem',
                fontWeight: 600,
                boxShadow: state.isFocused
                  ? '0 0 0 3px rgba(35, 124, 88, 0.1)'
                  : '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                borderRadius: '0.75rem',
                transition: 'all 0.2s',
                cursor: 'pointer',
                backgroundColor: 'white',
                '&:hover': {
                  borderColor: '#237c58',
                  boxShadow: '0 0 0 3px rgba(35, 124, 88, 0.05)'
                }
              }),
              menuPortal: (base: any) => ({
                ...base,
                zIndex: 9999
              }),
              menu: (base: any) => ({
                ...base,
                borderRadius: '0.75rem',
                overflow: 'hidden',
                boxShadow:
                  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                border: '1px solid #e5e7eb'
              }),
              menuList: (base: any) => ({
                ...base,
                padding: '0.25rem'
              }),
              valueContainer: (base: any) => ({
                ...base,
                padding: '0 12px'
              }),
              indicatorSeparator: (base: any) => ({
                ...base,
                display: 'none'
              }),
              dropdownIndicator: (base: any, state: any) => ({
                ...base,
                padding: '8px',
                color: state.isFocused ? '#237c58' : '#6b7280',
                transition: 'all 0.2s',
                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                '&:hover': {
                  color: '#237c58'
                }
              }),
              option: (base: any, state: any) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? '#237c58'
                  : state.isFocused
                  ? '#e9f2ee'
                  : 'transparent',
                color: state.isSelected ? 'white' : '#374151',
                fontSize: '0.875rem',
                fontWeight: state.isSelected ? 600 : 500,
                borderRadius: '0.5rem',
                margin: '0.125rem 0',
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:active': {
                  backgroundColor: '#237c58'
                }
              })
            }}
            onChange={(value: ValueType<{ value: number; label: number }, false>) => {
              handleItemsPerPage(value ? value.value : 10);
            }}
          />
        </div>
      </div>
    </div>
  );
};
